import { Modal } from "../Modal.js";
import { SettingsEditor } from "../settings/SettingsEditor.js";

/**
 * The header's settings dialog.
 *
 * The design's version is a mock: a hardcoded operator name and photograph, an
 * installation ID, a "Hardware Warranty Active (25-Yr System)" badge, a BMS
 * firmware version, a storm-guard switch wired to nothing, and a Save button
 * whose entire effect is to show "Saved Configuration" for 800ms. Every field
 * in it describes hardware this deployment does not have.
 *
 * What it shows instead is the real instance settings, through the same form
 * and the same authenticated write the Settings view uses -- one editor, one
 * write path, appearing in two places. A reader with `settings:read` but not
 * `settings:write` gets the read-only rendering here as well.
 */
export function SettingsModal({ canWrite, onClose }: { canWrite: boolean; onClose: () => void }) {
  return (
    <Modal title="Settings" onClose={onClose} className="md:max-w-2xl">
      <SettingsEditor canWrite={canWrite} />
    </Modal>
  );
}
